<!--报表 盘库盈亏表-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form size="small" :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="盘库日期：">
            <el-date-picker size="medium" v-model="searchForm.ENTRY_DATE" type="date" value-format="yyyy-MM-dd"
              placeholder="选择日期" style="width: 200px">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" class="btn" @click="onSubmit" :loading="loading">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col>
        <el-table :data="tableData" max-height="520" border stripe show-summary size="medium">
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="GYS_NAME" label="供应商"></el-table-column>
          <el-table-column prop="ENTRY_DATE" label="日期"> </el-table-column>
          <el-table-column prop="PK_VALUE" label="盘盈/盘亏">
            <template slot-scope="scope">
              <span :style="isFill(scope.row.PK_VALUE)">
                {{ scope.row.PK_VALUE > 0 ? `+${scope.row.PK_VALUE}` : scope.row.PK_VALUE }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="BEFORE_WORTH" label="盘前金额"> </el-table-column>
          <el-table-column prop="AFTER_WORTH" label="盘后金额"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-view" @click="detail(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { profitFun } from 'api/warehouseManager';

export default {
  data() {
    return {
      loading: false,
      searchForm: {},
      tableData: [],
      currentPage: 1,
      totalCount: 0,
      pageSize: 20,
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.$set(this.searchForm, 'ENTRY_DATE', this.$store.state.PROFITLOSSTABLE_ALL.ENTRY_DATE);
    if (this.$store.state.PROFITLOSSTABLE_ALL.CURRENTPAGE) {
      this.currentPage = this.$store.state.PROFITLOSSTABLE_ALL.CURRENTPAGE;
    }
    this.queryDate();
  },
  methods: {
    // --------------------------获取数据
    queryDate() {
      this.$store.dispatch('PROFITLOSSTABLE_ALL', { ENTRY_DATE: this.searchForm.ENTRY_DATE, CURRENTPAGE: this.currentPage });
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.ENTRY_DATE) {
        params.ENTRY_DATE = this.searchForm.ENTRY_DATE;
      }
      this.loading = true;
      profitFun(params).then((result) => {
        if (result[0]) {
          this.tableData = result[0].list;
          this.totalCount = result[0].TOTAL_COUNT;
        } else {
          this.tableData = [];
          this.totalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 判断盈亏，显示不同的颜色，盈/亏
    isFill(val) {
      return val >= 0 ? 'color: #67C23A' : 'color: #F56C6C';
    },
    onSubmit() {
      this.currentPage = 1;
      this.queryDate();
    },
    handleCurrentChange() {
      this.queryDate();
    },
    detail(row) {
      this.$router.push({ path: '/stockDetail/detail' });
      sessionStorage.setItem('pk_id', row.ID);
      sessionStorage.setItem('pk_code', row.PK_CODE);
      sessionStorage.setItem('gysName', row.GYS_NAME);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tableManage/profitLossTable.vue